export var studentModel = [
    {
        tag: "2f_text_82",
        length: "2f_text_83",
        location: "2f_text_84",
        image: require("@/assets/images/otolith/BSB_13_L_age26-Marissa.jpg"),
        imageDescription: "wv_2f_103_accessible",
        thumbnailDescription: "wv_2f_113_accessible",
        
        
        sonification: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/wv_2f_image_03_sonification/otolith-1.wav",
        expertImage: require("@/assets/images/otolith/gmri-otolith-id-13.png"),
        
        ageHeader: "2f_text_16",
        ageBody: "2f_text_17",
        altAgeHeader: "2f_text_16",
        altAgeBody: "wv_2f_text_17_accessible",
        
        compareHeader: "2f_text_21",
        compareBody: "2f_text_22",
        altCompareHeader: "2f_text_21",
        altCompareBody: "2f_text_22",
        
        expertHeader: "2f_text_27",
        expertBody: "2f_text_28",
        altExpertHeader: "wv_2f_text_27_accessible",
        altExpertBody: "2f_text_28",
        
        finalPrompt: "2f_text_29",
        estimatesHeader: "2f_text_23",
        estimates: ["2f_text_24", "2f_text_25", "2f_text_26"],
        age: 0,
        tracingImage: "",

        altUnplottedPointLabel: "wv_2f_105_accessible",
        altPlottedPointLabel: "wv_2f_106_accessible",
        pointLocation: {
            x: -1,
            y: -1
        }
    },
    {
        tag: "2f_text_85",
        length: "2f_text_86",
        location: "2f_text_87",
        image: require("@/assets/images/otolith/BSB_214_L_age44-Marissa.jpg"),
        imageDescription: "wv_2f_105_accessible",
        thumbnailDescription: "wv_2f_114_accessible",

        sonification: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/wv_2f_image_05_sonification/otolith-2.wav",
        expertImage: require("@/assets/images/otolith/gmri-otolith-id-214.png"),
        
        ageHeader: "2f_text_30",
        ageBody: "2f_text_31",
        altAgeHeader: "2f_text_30",
        altAgeBody: "wv_2f_text_31_accessible",
        
        compareHeader: "2f_text_35",
        compareBody: "2f_text_36",
        altCompareHeader: "2f_text_35",
        altCompareBody: "2f_text_36",
        
        expertHeader: "2f_text_41",
        expertBody: "2f_text_42",
        altExpertHeader: "wv_2f_text_41_accessible",
        altExpertBody: "2f_text_42",
        
        finalPrompt: "2f_text_43",
        estimatesHeader: "2f_text_37",
        estimates: ["2f_text_38", "2f_text_39", "2f_text_40"],
        age: 0,
        tracingImage: "",

        altUnplottedPointLabel: "wv_2f_107_accessible",
        altPlottedPointLabel: "wv_2f_108_accessible",
        pointLocation: {
            x: -1,
            y: -1
        }
    },
    {
        tag: "2f_text_88",
        length: "2f_text_89",
        location: "2f_text_90",
        image: require("@/assets/images/otolith/BSB_220_L_age5-Marissa.jpg"),
        imageDescription: "wv_2f_107_accessible",
        thumbnailDescription: "wv_2f_115_accessible",


        sonification: "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/wv_2f_image_07_sonification/otolith-3.wav",
        expertImage: require("@/assets/images/otolith/gmri-otolith-id-220.png"),
        
        ageHeader: "2f_text_44",
        ageBody: "2f_text_45",
        altAgeHeader: "2f_text_44",
        altAgeBody: "wv_2f_text_45_accessible",
        
        compareHeader: "2f_text_49",
        compareBody: "2f_text_50",
        altCompareHeader: "2f_text_49",
        altCompareBody: "2f_text_50",
        
        expertHeader: "2f_text_55",
        expertBody: "2f_text_56",
        altExpertHeader: "2f_text_55_accessible",
        altExpertBody: "2f_text_56",
        
        finalPrompt: "2f_text_57",
        estimatesHeader: "2f_text_51",
        estimates: ["2f_text_52", "2f_text_53", "2f_text_54"],
        age: 0,
        tracingImage: "",

        altUnplottedPointLabel: "wv_2f_109_accessible",
        altPlottedPointLabel: "wv_2f_110_accessible",
        pointLocation: {
            x: -1,
            y: -1
        }
    }
]
      